import { Info } from "lucide-react";

export function PoliciesTab({ tour }) {
  return (
    <div className="space-y-8">
      <div>
        <h4 className="mb-2 font-display text-sm font-semibold text-slate-900">Booking Policy</h4>
        <p className="text-sm leading-relaxed text-slate-600">{tour.booking_policy || "Contact us for booking terms."}</p>
      </div>
      <div>
        <h4 className="mb-2 font-display text-sm font-semibold text-slate-900">Cancellation & Amendment Policy</h4>
        {tour.cancellation_policy?.split("\n\n").map((para, i) => (
          <p key={i} className="mb-2 text-sm leading-relaxed text-slate-600">{para}</p>
        ))}
      </div>
      {tour.important_notes?.length > 0 && (
        <div>
          <h4 className="mb-2 font-display text-sm font-semibold text-slate-900">Important Notes</h4>
          <ul className="space-y-2">
            {tour.important_notes.map((note, i) => (
              <li key={i} className="flex items-start gap-2 text-sm text-slate-600">
                <Info className="mt-0.5 h-4 w-4 shrink-0 text-[hsl(var(--brand-primary))]" />
                <span>{note}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
      {tour.region_addons?.length > 0 && (
        <div>
          <h4 className="mb-2 font-display text-sm font-semibold text-slate-900">Optional Add-ons</h4>
          <ul className="grid grid-cols-1 gap-2 sm:grid-cols-2">
            {tour.region_addons.map((addon, i) => (
              <li key={i} className="flex items-center justify-between rounded-lg border bg-slate-50 px-3 py-2 text-sm text-slate-600">
                <span>{addon.activity_name}</span>
                <span className="font-semibold text-slate-800">
                  {addon.price_per_person ? `\u20b9${addon.price_per_person}` : "On Request"}
                </span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
